export const PAYMENT_REJECTED = '4';
export const PAYMENT_SUCCEEDED = '7';
